import React, { useState, useEffect } from 'react'
import { toolApi, categoryApi } from '../services/api'

const OnlineToolsSection = () => {
  const [tools, setTools] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      const [toolsRes, categoriesRes] = await Promise.all([
        toolApi.list(),
        categoryApi.list('online')
      ])
      
      if (toolsRes.code === 0) setTools(toolsRes.data)
      if (categoriesRes.code === 0) setCategories(categoriesRes.data)
    } catch (err) {
      setError('加载数据失败')
    } finally {
      setLoading(false)
    }
  }

  const getToolsByCategory = (categoryId) => {
    return tools.filter(tool => tool.category_id === categoryId)
  }

  if (loading) {
    return (
      <section className="section">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>加载中...</p>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="section">
        <div className="error">{error}</div>
      </section>
    )
  }

  return (
    <section className="section">
      <div className="section-header">
        <span className="section-title">视频推荐</span>
        <span className="section-count">// 精选视频</span>
      </div>
      
      {categories.map(category => {
        const categoryTools = getToolsByCategory(category.id)
        if (categoryTools.length === 0) return null
        
        return (
          <div key={category.id}>
            <div className="category-label">{category.name}</div>
            <div className="card-grid grid-2">
              {categoryTools.map((tool, index) => (
                <div 
                  key={tool.id} 
                  className="movie-card card-anim"
                  style={{ animationDelay: `${index * 0.05}s` }}
                  onClick={() => {
                    if (tool.url) {
                      window.open(tool.url, '_blank')
                    }
                  }}
                >
                  <div 
                    className="movie-thumb" 
                    style={{ background: tool.banner_gradient || 'linear-gradient(135deg,#1a1a2e,#16213e)' }}
                  >
                    {(() => {
                      // Base64 图片（兼容旧数据）
                      if (tool.icon && tool.icon.startsWith('data:image')) {
                        return <img src={tool.icon} alt={tool.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      }
                      // URL 图片（新数据）
                      if (tool.icon && tool.icon.startsWith('http')) {
                        return <img src={tool.icon} alt={tool.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      }
                      // emoji 或默认图标
                      return tool.icon || '🎬'
                    })()}
                  </div>
                  <div className="movie-info">
                    <div className="movie-title">{tool.name}</div>
                    <div className="movie-desc">{tool.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default OnlineToolsSection
